import { ElementRef, NgZone } from '@angular/core';
import { PlaybackService, PlaybackSession, AssetResolution, HTMLMediaPlaybackSession, PlaybackHints, PlaybackItem } from 'media-playback';
import { Injectable } from '@angular/core';
import { ApiAvAsset } from '@tytapp/api';
//import * as Hls from 'hls.js';

declare let Hls: any; // TODO: fix this after hls.js can support SSR

/**
 * HLS playback service
 */
@Injectable()
export class HLSGoogleCastPlaybackService implements PlaybackService {

    constructor(private ngZone: NgZone) {
    }

    get id() {
        return 'hls-googlecast';
    }

    /**
     * Try to resolve using this service before regular services.
     */
    get priority() {
        return 10;
    }

    resolve(item: PlaybackItem): AssetResolution {
        let asset: ApiAvAsset = item.item.asset;
        let url = asset.url;

        if (!window['isGoogleCastReceiver'])
            return null;

        if (!url.endsWith('.m3u8'))
            return null;

        return {
            item,
            service: this,
            asset,
            data: {}
        };
    }

    currentPlayer: cast.player.api.Player;
    playerSdkLoaded: Promise<void> = null;
    playerElement: HTMLMediaElement;

    /**
     * Play the given media resolution within the given root element.
     */
    async play(mediaResolution: AssetResolution, rootElement: ElementRef, hints?: PlaybackHints): Promise<PlaybackSession> {

        console.log(`HLS/GoogleCast playback implementation started.`);

        if (!this.playerSdkLoaded) {
            console.log(`HLS/GoogleCast: Loading MPL SDK...`);
            this.playerSdkLoaded = new Promise((resolve, reject) => {
                let script = document.createElement('script');
                script.src = "//www.gstatic.com/cast/sdk/libs/mediaplayer/1.0.0/media_player.js";
                script.onload = function () {
                    console.log(`HLS/GoogleCast: MPL SDK loaded`);
                    resolve();
                };
                document.body.appendChild(script);
            });
        }

        await this.playerSdkLoaded;

        let assetUrl = mediaResolution.asset.url;

        if (!this.playerElement) {
            this.playerElement = document.createElement('video');
            this.playerElement.controls = false;
            this.playerElement.autoplay = true;
        }

        let video = this.playerElement;

        if (!hints)
            hints = {};

        rootElement.nativeElement.appendChild(video);

        // MPL: Must unload before starting again.

        if (this.currentPlayer) {
            console.log(`GoogleCast/HLSPlayback: Disposing previous MPL Player...`);
            this.currentPlayer.unload();
            this.currentPlayer = null;
        }

        console.log(`GoogleCast/HLSPlayback: Preparing to play '${assetUrl}'...`);
        let host = new cast.player.api.Host({
            mediaElement: video,
            url: assetUrl
        });

        host.onError = (errorCode) => {
            console.error(`GoogleCast/HLSPlayback(${assetUrl}): Error received from MPL host with code ${errorCode}`);
        };

        let protocol = cast.player.api.CreateHlsStreamingProtocol(host);
        let player = new cast.player.api.Player(host);
        this.currentPlayer = player;

        let result = player.load(protocol);

        console.log(`GoogleCast/HLSPlayback: Waiting for video to be ready before returning session...`);
        await new Promise<void>((resolve, reject) => {
            let interval;
            interval = setInterval(() => {
                if (video.currentTime > 0) {
                    clearInterval(interval);
                    resolve();
                }
            }, 100);
        });

        console.log(`GoogleCast/HLSPlayback: Ready!`);

        return new HTMLMediaPlaybackSession(mediaResolution.item, this, video, mediaResolution.asset, hints.startPosition || 0);
    }
}
